const REFERRER_STORAGE_KEY = 'fam-referrer'

export function captureInitialReferrer() {
  const params = new URLSearchParams(window.location.search)
  const keyValues = []
  let type = ''

  params.forEach((value, key) => {
    const normalizedKey = key.toLowerCase()
    if (!normalizedKey.startsWith('ext')) return

    if (normalizedKey === 'extorigin') {
      type = (value || '').trim()
      return
    }

    keyValues.push({
      key: key.substring(3),
      value: value ?? '',
    })
  })

  if (!type && keyValues.length === 0) return null

  const payload = {
    type,
    keyValues,
  }

  sessionStorage.setItem(REFERRER_STORAGE_KEY, JSON.stringify(payload))
  return payload
}

export function getStoredReferrer() {
  let rawReferrer = sessionStorage.getItem(REFERRER_STORAGE_KEY)

  if (!rawReferrer) return null

  try {
    return JSON.parse(rawReferrer)
  } catch (error) {
    return null
  }
}

export function clearStoredReferrer() {
  sessionStorage.removeItem(REFERRER_STORAGE_KEY)
  localStorage.removeItem(REFERRER_STORAGE_KEY)
}
